/*
 * -----------------------------------------------------------------------
 *  <copyright file="report-definition.ts" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { gql } from '@apollo/client';
import { ReportDefinitionFragment } from './fragments';

export const GET_REPORT_DEFINITIONS = gql`
    query getReportDefinitions {
        getReportDefinitions {
            ...ReportDefinitionFields
        }
    }
    ${ReportDefinitionFragment}
`;

export const GET_REPORT_DEFINITION_OPTIONS = gql`
    query reportDefinitionOptions {
        reportDefinitionOptions {
            ...ReportDefinitionFields
        }
    }
    ${ReportDefinitionFragment}
`;

export const DELETE_CUSTOM_REPORT = gql`
    mutation deleteReportDefinition($id: ObjectId!, $reason: String) {
        deleteReportDefinition(id: $id, reason: $reason)
    }
`;

export const UPSERT_REPORT_DEFINITION = gql`
    mutation upsertReportDefinition($reportDefinition: ReportDefinitionInput!, $isUserReport: Boolean) {
        upsertReportDefinition(reportDefinition: $reportDefinition, isUserReport: $isUserReport) {
            ...ReportDefinitionFields
        }
    }
    ${ReportDefinitionFragment}
`;
